<div class="card">
  <div>{{message}}</div>
  <div style="margin-top: 15px;">
    <button (click)="respond(true)" style="margin-right: 10px"><span>Yes</span></button>
    <button (click)="respond(false)"><span>Cancel</span></button>
  </div>
</div>
